import { Icon } from '@chakra-ui/react';
import { MdBarChart, MdHome, MdLock, MdManageAccounts, MdMoney, MdOutlineShoppingCart, MdPerson } from 'react-icons/md';

// Admin Imports
import Clients from 'views/admin/clients';
import MainDashboard from 'views/admin/default';
import Orders from 'views/admin/order';
import { default as Finance, default as Profile } from 'views/admin/profile';
import Reports from 'views/admin/reports';
import RecoverPass from 'views/auth/recoverpass';
import Register from 'views/auth/register';
import Login from 'views/auth/signIn';

// Auth Imports

const routes = [
	{
		name: 'Dashboard',
		layout: '/admin',
		path: '/default',
		icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
		component: MainDashboard,
		show: true,
	},
	{
		name: 'Orçamentos',
		layout: '/admin',
		path: '/order',
		icon: <Icon as={MdOutlineShoppingCart} width='20px' height='20px' color='inherit' />,
		component: Orders,
		show: true,
	},
	{
		name: 'Relatórios',
		layout: '/admin',
		icon: <Icon as={MdBarChart} width='20px' height='20px' color='inherit' />,
		path: '/reports',
		component: Reports,
		show: true,
	},

	{
		name: 'Financeiro',
		layout: '/admin',
		icon: <Icon as={MdMoney} width='20px' height='20px' color='inherit' />,
		path: '/finance',
		component: Finance,
		show: true,
	},

	{
		name: 'Pesssoas',
		layout: '/admin',
		path: '/clients',
		icon: <Icon as={MdManageAccounts} width='20px' height='20px' color='inherit' />,
		component: Clients,
		show: true,
	},
	{
		name: 'Perfil',
		layout: '/admin',
		path: '/profile',
		icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
		component: Profile,
		show: true,
	},
	{
		name: 'Login',
		layout: '/auth',
		path: '/sign-in',
		icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
		component: Login,
		show: false,
	},
	{
		name: 'Recuperar Senha',
		layout: '/auth',
		path: '/recover',
		icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
		component: RecoverPass,
		show: false,
	},
	{
		name: 'Cadastrar',
		layout: '/auth',
		path: '/register',
		icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
		component: Register,
		show: false,
	},


];

export default routes;
